import AppForm from "@/app/components/atomic/AppForm"
import Filter, { FilterSkeleton } from "@/app/components/auctor/filter/Filter"
import { FILTER_COL_SPAN_HALF, FilterVariant, IAppliedFilter, IFilterConfig } from "@/app/models/auctor"
import { getFilterDisplayCondition } from "@/app/utils/filters-utils"

interface FilterListProps {
    filtersConfig: any
    appliedFilters: IAppliedFilter[]
    className?: string
    updateAppliedFilter: any
    queryParams?: Record<string, string> | null
    variant?: FilterVariant
}

const getToolFilterWidthClass = (filter: IFilterConfig) =>
    filter.col_span === FILTER_COL_SPAN_HALF ? "md:col-span-1" : "md:col-span-2"

export default function FilterList({
    filtersConfig,
    appliedFilters,
    updateAppliedFilter,
    className = "",
    queryParams = null,
    variant = "default",
}: FilterListProps) {
    const getFilterClassName = (filter: IFilterConfig) => (variant === "tool" ? getToolFilterWidthClass(filter) : "")

    return (
        <AppForm className={className} dataTest="filter-list">
            {filtersConfig?.map((filter: any) => {
                if (getFilterDisplayCondition(filter, appliedFilters, queryParams)) {
                    const appliedFilter = appliedFilters.find((f) => f.filterId === filter.unique_id)
                    return (
                        <Filter
                            key={`filter-${filter.unique_id}`}
                            filterConfig={filter}
                            // @ts-ignore because if we have a filter we have an applied filter
                            appliedFilter={appliedFilter}
                            updateAppliedFilter={updateAppliedFilter}
                            variant={variant}
                            className={getFilterClassName(filter)}
                        />
                    )
                }
            })}
        </AppForm>
    )
}

export function FiltersSkeleton({
    countDesktop = 3,
    countAllDisplays = 2,
    countMobile = 2,
}: {
    countDesktop?: number
    countAllDisplays?: number
    countMobile?: number
}) {
    return (
        <>
            {Array.from(Array(countAllDisplays).keys())?.map((idx: number) => (
                <FilterSkeleton key={idx} />
            ))}

            {Array.from(Array(countDesktop).keys())?.map((idx: number) => (
                <FilterSkeleton className="hidden lg:block" key={idx} />
            ))}
        </>
    )
}
